import { render, staticRenderFns } from "./ManageENSContainer.vue?vue&type=template&id=4525d830&scoped=true&"
import script from "./ManageENSContainer.vue?vue&type=script&lang=js&"
export * from "./ManageENSContainer.vue?vue&type=script&lang=js&"
import style0 from "./ManageENSContainer.vue?vue&type=style&index=0&id=4525d830&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4525d830",
  null
  
)

export default component.exports